import { Outlet } from 'react-router-dom';
import { Stack } from '@prenuvo/halo';

import { api } from '@/api';
import { AddendumProvider } from '@/core/addendum';
import { useStudyGuard } from '@/shared/guard';

import { Header, StudyModeDialog } from '../../component';
import {
  useInitializePreferences,
  useInitializeReport,
  useSyncComparisonStoreWithRoute,
} from '../../hook';

export function ComparisonLayout() {
  const {
    radiologistScan: { patientID: patientId },
    studyId,
  } = useStudyGuard();

  api.fct.comparison.query.useGetPriorStudies({
    payload: { params: { currentStudyId: studyId, patientId } },
  });

  useSyncComparisonStoreWithRoute({ isOnComparisonsRoute: true, studyId });

  useInitializePreferences();
  useInitializeReport();

  return (
    <AddendumProvider>
      <Stack className="h-screen" gap={0} variant="vertical">
        <Header showActions={false} />
        <main className="flex h-[calc(100%-5rem)] min-h-0 overflow-hidden pr-0 pb-0">
          <Stack className="@container min-h-0 min-w-0 flex-1">
            <Stack className="relative min-w-0 flex-1 overflow-hidden" variant="vertical">
              <Stack
                className="reporting-content-scroll-area min-h-0 flex-1 overflow-hidden"
                variant="vertical"
              >
                <Outlet />
              </Stack>
            </Stack>
          </Stack>
        </main>
        <StudyModeDialog />
      </Stack>
    </AddendumProvider>
  );
}
